import React from 'react';
import LuckyCalImage from '../../images/events/LuckyNumberCalendar.jpg';
import { Container, Row, Col } from 'react-bootstrap';

class LuckyCalendarPage extends React.Component {
  render() {
    return (
      <Container fluid>
        <Row className="p-2" flex>
          <Col md="9" className="gap-2">
            <h1>2025 Lucky Number Calendar</h1>
            <br /><h1>How it Works?</h1>
          </Col>
          <Col md="3" className="gap-2">
            <img src={LuckyCalImage} className="img-fluid rounded" alt="Lucky Number Calendar" />
          </Col>
        </Row>
        <Row className="p-2">
          <Col md="9" className="flex-start">
            <ul>
              <li>• It works like a raffle that happens every day!</li>
              <li>• By purchasing this $30 calendar, you will receive a number ranging from 000 to 999</li>
              <li>• Each day of the week in 2025, except Sundays, you have a chance of winning $50
                if your number is drawn.</li>
              <li>• On a special day each month, you could win $100.</li>
              <li>• We will use the evening Ohio Pick 3 number as our random number for the
                raffle. This ensures that the number is truly random.</li>
              <li>• If you win, we will send your money to you within 1 to 2 weeks.</li>
              <li>• We only ask for your name, address, email & phone so that we can send you the
                money if you win. We will not sell or distribute this data.</li>
              <li>• All of the profits will go to St Mary Catholic Church.</li>
            </ul>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default LuckyCalendarPage;